export enum CodePermissionEnum {
	Header_MyAccount_Access = 'header:my_account:access',
	Header_Logout_Access = 'header:logout:access',
	Header_Home_Access = 'header:home:access',
	QuickSimulation_BackToRooms = 'quick-estimation:back-to-rooms'
}
